export const NotesRenderKey = {
    Notes: 'notes', //Note selection screen
    Protocols: 'dispo', //Protocol selection screen
    Review: 'review', //Note review screen
    Sent: 'sent', //Sent message screen
};
//# sourceMappingURL=types.js.map